import { queryOptions } from "@tanstack/react-query";

import { getWebhooksView } from "./server-fns";

export function webhooksQueryKey() {
  return ["webhooks"] as const;
}

export function webhooksQueryOptions() {
  return queryOptions({
    queryKey: webhooksQueryKey(),
    queryFn: () => getWebhooksView(),
    staleTime: 30_000,
  });
}
